<div id="printContent">
  <table class="table table-borderless stripes">
    <thead>
      <tr>
        <th>Date</th>
        <th>Time</th>
        <th>Patient Name</th>
        <th>Type</th>
        <th>Rendering Provider</th>
        <th>Service Site</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let result of data, let i = index">
        <td>
          {{result.Date | date: 'MM/dd/yyyy'}}
        </td>
        <td>
          {{result.Date | date: 'shortTime'}}
        </td>
        <td>
          {{result.PatientName}}
        </td>
        <td>
          {{result.AppointmentType}}
        </td>
        <td>
          {{result.RenderingProvider}}
        </td>
        <td>
          {{result.ServiceSite}}
        </td>
      </tr>
    </tbody>
  </table>
</div>
